(function () {
  'use strict';

  var STORAGE_KEY = 'retroparty:wishlist';
  var MAX_ITEMS = 60;
  var toastTimer = null;

  function normalizeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      url.hash = '';
      return url.pathname + url.search;
    } catch (error) {
      return String(value || '');
    }
  }

  function normalizeHandle(value) {
    var handle = String(value || '').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9-]*$/.test(handle) ? handle : '';
  }

  function getProductHandle(item) {
    var directHandle = normalizeHandle(item && item.handle);
    if (directHandle) return directHandle;

    try {
      var url = new URL(item && item.url || '', window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? normalizeHandle(decodeURIComponent(match[1])) : '';
    } catch (error) {
      return '';
    }
  }

  function getWishlistKey(item) {
    var handle = getProductHandle(item);
    if (handle) return 'product:' + handle;

    var url = normalizeUrl(item && item.url).split('?')[0].replace(/\/$/, '').toLowerCase();
    return url ? 'url:' + url : '';
  }

  function readWishlist() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(raw)) return [];

      var seen = {};
      return raw
        .filter(function (item) {
          return item && (item.url || item.handle);
        })
        .map(function (item) {
          return {
            title: String(item.title || ''),
            url: normalizeUrl(item.url),
            image: String(item.image || ''),
            handle: String(item.handle || ''),
            variantId: String(item.variantId || '')
          };
        })
        .filter(function (item) {
          var key = getWishlistKey(item);
          if (!key || seen[key]) return false;
          seen[key] = true;
          return true;
        })
        .slice(0, MAX_ITEMS);
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (error) {
      return false;
    }
    return true;
  }

  function setButtonState(button, active) {
    var ariaLabel = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
    var textLabel = active ? 'Dans vos favoris' : 'Ajouter aux favoris';

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', ariaLabel);

    var text = button.querySelector('[data-rp-wishlist-text]');
    if (text) text.textContent = textLabel;
  }

  function refreshButtons() {
    var items = readWishlist();
    document.querySelectorAll('[data-rp-wishlist]').forEach(function (button) {
      var buttonKey = getWishlistKey({
        url: button.getAttribute('data-product-url'),
        handle: button.getAttribute('data-product-handle')
      });
      var active = items.some(function (entry) {
        return getWishlistKey(entry) === buttonKey;
      });
      setButtonState(button, active);
    });
  }

  function refreshWishlistCount() {
    var count = readWishlist().length;

    document.querySelectorAll('[data-rp-wishlist-count]').forEach(function (badge) {
      badge.hidden = count === 0;
      badge.textContent = count > 99 ? '99+' : String(count);
    });

    document.querySelectorAll('[data-rp-wishlist-link]').forEach(function (link) {
      link.classList.toggle('has-items', count > 0);
      link.setAttribute(
        'aria-label',
        count ? 'Voir vos favoris (' + count + ')' : 'Voir vos favoris'
      );
    });
  }

  function updateWishlistHero(items) {
    var total = items.length;
    var labelOne = getWishlistString('rpWishlistLabelOne', 'produit sauvegardé');
    var labelMany = getWishlistString('rpWishlistLabelMany', 'produits sauvegardés');

    document.querySelectorAll('[data-rp-wishlist-total]').forEach(function (node) {
      node.textContent = String(total);
    });

    document.querySelectorAll('.rp-wishlist-hero__label').forEach(function (node) {
      node.textContent = total > 1
        ? labelMany
        : labelOne;
    });
  }

  function getWishlistString(key, fallback) {
    var mount = document.querySelector('[data-rp-wishlist-page]');
    return mount && mount.dataset[key] ? mount.dataset[key] : fallback;
  }

  function normalizeInternalPath(value, fallback) {
    try {
      var url = new URL(value || fallback, window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return fallback;
      if (url.origin !== window.location.origin) return fallback;
      return url.pathname + url.search;
    } catch (error) {
      return fallback;
    }
  }

  function getWishlistProductPath(item, fallback) {
    var handle = getProductHandle(item);
    if (handle) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
    }

    return normalizeInternalPath(item && item.url, fallback);
  }

  function normalizeImageUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
      if (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com') return '';
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function createWishlistElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function renderWishlistPage() {
    var mount = document.querySelector('[data-rp-wishlist-page]');
    if (!mount) return;

    var items = readWishlist();
    updateWishlistHero(items);
    while (mount.firstChild) mount.removeChild(mount.firstChild);

    if (!items.length) {
      var empty = createWishlistElement('section', 'rp-wishlist-empty');
      var emptyIcon = createWishlistElement('div', 'rp-wishlist-empty__icon', '♡');
      emptyIcon.setAttribute('aria-hidden', 'true');
      empty.appendChild(emptyIcon);
      empty.appendChild(createWishlistElement('h2', '', getWishlistString('rpWishlistEmptyTitle', 'Votre liste est vide')));
      empty.appendChild(createWishlistElement('p', '', getWishlistString('rpWishlistEmptyText', 'Ajoutez un produit avec le cœur pour le retrouver ici plus tard.')));
      var emptyLink = createWishlistElement('a', 'button button--primary', getWishlistString('rpWishlistViewProducts', 'Voir les produits'));
      emptyLink.href = normalizeInternalPath(mount.dataset.rpAllProductsUrl, '/collections/all');
      empty.appendChild(emptyLink);
      mount.appendChild(empty);
      return;
    }

    var summary = createWishlistElement('div', 'rp-wishlist-summary');
    summary.appendChild(createWishlistElement('span', '', items.length + ' ' + (items.length > 1
      ? getWishlistString('rpWishlistSavedMany', 'favoris')
      : getWishlistString('rpWishlistSavedOne', 'favori'))));
    mount.appendChild(summary);

    var grid = createWishlistElement('div', 'rp-wishlist-page__grid');
    items.forEach(function (item) {
      var href = getWishlistProductPath(item, '/collections/all');
      var article = createWishlistElement('article', 'rp-wishlist-page__item');
      var mediaLink = createWishlistElement('a', 'rp-wishlist-page__media');
      mediaLink.href = href;
      mediaLink.setAttribute('data-rp-wishlist-product-link', '');
      var imageUrl = normalizeImageUrl(item.image);
      if (imageUrl) {
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = item.title;
        image.loading = 'lazy';
        mediaLink.appendChild(image);
      } else {
        var placeholder = createWishlistElement('div', 'rp-wishlist-page__placeholder', 'RP');
        placeholder.setAttribute('aria-hidden', 'true');
        mediaLink.appendChild(placeholder);
      }
      article.appendChild(mediaLink);

      var body = createWishlistElement('div', 'rp-wishlist-page__body');
      var badges = createWishlistElement('div', 'rp-wishlist-page__badges');
      badges.appendChild(createWishlistElement('span', 'rp-wishlist-page__saved', getWishlistString('rpWishlistSavedLabel', 'Favori')));
      body.appendChild(badges);

      var titleLink = createWishlistElement('a', 'rp-wishlist-page__title', item.title);
      titleLink.href = href;
      titleLink.setAttribute('data-rp-wishlist-product-link', '');
      body.appendChild(titleLink);

      var actions = createWishlistElement('div', 'rp-wishlist-page__actions');
      var viewLink = createWishlistElement('a', 'rp-wishlist-page__view', getWishlistString('rpWishlistViewProduct', 'Voir le produit'));
      viewLink.href = href;
      viewLink.setAttribute('data-rp-wishlist-product-link', '');
      viewLink.setAttribute('aria-label', getWishlistString('rpWishlistViewProduct', 'Voir le produit') + ' : ' + item.title);
      actions.appendChild(viewLink);
      var removeButton = createWishlistElement('button', 'rp-wishlist-page__remove', getWishlistString('rpWishlistRemove', 'Retirer'));
      removeButton.type = 'button';
      removeButton.setAttribute('data-rp-wishlist-remove', getWishlistKey(item));
      actions.appendChild(removeButton);
      body.appendChild(actions);
      article.appendChild(body);
      grid.appendChild(article);
    });
    mount.appendChild(grid);
  }

  function refreshLoyaltyPoints(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-rp-loyalty-points]').forEach(function (line) {
      var pointsPerEuro = Number(line.getAttribute('data-rp-points-per-euro')) || 0;
      var value = Math.floor(Number(variant.price || 0) * pointsPerEuro / 100);
      var output = line.querySelector('[data-rp-loyalty-points-value]');
      if (output) output.textContent = String(value);
      line.setAttribute('data-rp-variant-price', String(Number(variant.price || 0)));
    });
  }
  function refreshAll() {
    refreshButtons();
    refreshWishlistCount();
    renderWishlistPage();
  }

  function getToast() {
    var toast = document.getElementById('rp-wishlist-toast');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.id = 'rp-wishlist-toast';
    toast.className = 'rp-wishlist-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.hidden = true;
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(message) {
    var toast = getToast();

    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.hidden = false;

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.hidden = true;
      }, 220);
    }, 4200);
  }

  function productFromButton(button) {
    return {
      title: button.getAttribute('data-product-title') || '',
      url: normalizeUrl(button.getAttribute('data-product-url')),
      image: button.getAttribute('data-product-image') || '',
      handle: button.getAttribute('data-product-handle') || '',
      variantId: button.getAttribute('data-variant-id') || ''
    };
  }

  function toggleWishlist(product) {
    var productKey = getWishlistKey(product);
    if (!productKey) return;

    var items = readWishlist();
    var index = items.findIndex(function (entry) {
      return getWishlistKey(entry) === productKey;
    });

    if (index >= 0) {
      items.splice(index, 1);
      writeWishlist(items);
      refreshAll();
      showToast('Produit retiré des favoris');
      return;
    }

    items.unshift(product);
    writeWishlist(items);
    refreshAll();
    showToast('Produit ajouté aux favoris');
  }

  function removeWishlist(key) {
    var items = readWishlist().filter(function (entry) {
      return getWishlistKey(entry) !== key;
    });

    writeWishlist(items);
    refreshAll();
    showToast('Produit retiré des favoris');
  }

  function handleWishlistClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var productLink = target.closest('[data-rp-wishlist-product-link]');
    if (productLink) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var destination = normalizeInternalPath(productLink.getAttribute('href'), '');
      if (!destination) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(destination);
      return;
    }

    var removeButton = target.closest('[data-rp-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      removeWishlist(removeButton.getAttribute('data-rp-wishlist-remove'));
      return;
    }

    var button = target.closest('[data-rp-wishlist]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    toggleWishlist(productFromButton(button));
  }

  document.addEventListener('click', handleWishlistClick, true);

  window.RPWishlist = window.RPWishlist || {};
  window.RPWishlist.refresh = refreshAll;

  function init() {
    refreshAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      refreshLoyaltyPoints(event && event.data && event.data.variant);
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('retroparty:product-grid-updated', refreshAll);
  document.addEventListener('retroparty:products-appended', refreshAll);
  document.addEventListener('retroparty:variant-stock-state', function () {
    refreshButtons();
    refreshWishlistCount();
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    refreshAll();
  });
})();
